import { render, staticRenderFns } from "./dashboard_buyer.vue?vue&type=template&id=f9a4880a"
import script from "./dashboard_buyer.vue?vue&type=script&lang=js"
export * from "./dashboard_buyer.vue?vue&type=script&lang=js"
import style0 from "./dashboard_buyer.vue?vue&type=style&index=0&id=f9a4880a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports